import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/compare/qualys')({
  head: () => ({
    ...buildSeoHead({ path: '/compare/qualys', ...ROUTE_META['/compare/qualys'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Compare', path: '/compare' }, { name: 'Qualys', path: '/compare/qualys' }])),
      jsonLdScript(buildWebPageSchema({ path: '/compare/qualys', ...ROUTE_META['/compare/qualys'] })),
    ],
  }),
});
